const Countries = Object.freeze({
  SPAIN: "Spain",
  PORTUGAL: "Portugal",
});

class TruckloadForm extends HTMLElement {
  constructor() {
    super();

    this.productInputs = this.querySelectorAll("[name='bale-type']");
    this.phonePrefixSelector = this.querySelector("[data-phone-prefix]");
    this.phoneInput = this.querySelector("[data-phone-input]");
    this.phoneContactInput = this.querySelector("[data-contact-phone-input]");
    this.areaContactInput = this.querySelector("[data-contact-area-input]");
    this.countryContactInput = this.querySelector(
      "[data-contact-country-input]"
    );
    this.postalCodeSelector = this.querySelector("[data-postal-code]");

    this.addToCartButton = this.querySelector("[data-add-to-cart]");

    this.countrySelector = this.querySelector("[data-country]");
    this.spainAreaSelector = this.querySelector(".spain-areas");
    this.portugalAreaSelector = this.querySelector(".portugal-areas");

    this.options = this.querySelectorAll("[data-truckload-option]");

    if (this.hasAttribute("data-spain")) this.currentCountry = Countries.SPAIN;
    else this.currentCountry = Countries.PORTUGAL;

    this.termsInput = this.querySelector("#terms");
  }

  connectedCallback() {
    this.productInputs.forEach((input) => {
      input.addEventListener("click", this.handleInputChange.bind(this));
    });

    this.termsInput.addEventListener(
      "change",
      this.handleTermsInputChange.bind(this)
    );

    this.countrySelector.addEventListener("value-changed", (e) => {
      this.handleCountryChange(e.detail.newValue);
    });

    this.spainAreaSelector.addEventListener("value-changed", (e) => {
      this.handleAreaChange(e.detail.newValue);
    });

    this.portugalAreaSelector.addEventListener("value-changed", (e) => {
      this.handleAreaChange(e.detail.newValue);
    });

    this.phonePrefixSelector.addEventListener("value-changed", (e) => {
      this.handlePhoneValuesChange(e.detail.newValue);
    });

    this.phoneInput.addEventListener("change", (e) => {
      this.handlePhoneValuesChange();
    });

    this.addToCartButton.addEventListener("click", this.addToCart.bind(this));

    setTimeout(() => {
      this.updateBlockInformation();
    }, 500);
  }

  handleInputChange() {
    this.validateForm();
  }

  handleTermsInputChange() {
    this.validateForm();
  }

  handlePhoneValuesChange() {
    this.phoneContactInput.value =
      this.phonePrefixSelector.value + "" + this.phoneInput.value;
  }

  handleCountryChange(value) {
    switch (value) {
      case "Spain":
        this.spainAreaSelector.classList.remove("hidden");
        this.portugalAreaSelector.classList.add("hidden");
        this.currentCountry = Countries.SPAIN;
        this.countryContactInput.value = Countries.SPAIN;
        break;
      case "Portugal":
        this.spainAreaSelector.classList.add("hidden");
        this.portugalAreaSelector.classList.remove("hidden");
        this.currentCountry = Countries.PORTUGAL;
        this.countryContactInput.value = Countries.PORTUGAL;
        break;
    }
    this.updateBlockInformation();
  }

  handleAreaChange() {
    this.updateBlockInformation();

    this.areaContactInput.value = this.getSelectedArea();
  }

  getSelectedArea() {
    return this.currentCountry == Countries.SPAIN
      ? this.spainAreaSelector.value
      : this.portugalAreaSelector.value;
  }

  getSelectedVariantByOption(option) {
    const productInfo = this.getProductInfo(option);
    if (!productInfo) return;

    const selectedArea = this.getSelectedArea();
    if (!selectedArea) return;

    const selectedVariant = productInfo.product.variants.find((variant) => {
      console.log(variant.title, " - ", selectedArea)
      return variant.title == selectedArea;
    });
    console.log("SELECTED:", selectedVariant);

    return selectedVariant;
  }

  getSelectedOption() {
    for (const option of this.options) {
      const selectedInput = option.querySelector("input[type='radio']:checked");
      if (selectedInput) return option;
    }

    return;
  }

  updateBlockInformation() {
    this.options.forEach((option) => {
      const selectedVariant = this.getSelectedVariantByOption(option);
      if (!selectedVariant) return;

      const pricePerKgElement = option.querySelector("[data-price-per-kg]");
      const pricePerBaleElement = option.querySelector("[data-price-per-bale]");
      const variantPriceElement = option.querySelector("[data-variant-price]");
      const areaElement = option.querySelector("[data-area]");

      pricePerKgElement.innerHTML = selectedVariant.pricePerKg;
      pricePerBaleElement.innerHTML = selectedVariant.pricePerBale;
      variantPriceElement.innerHTML = selectedVariant.price;
      areaElement.innerHTML = this.getSelectedArea();

      option.setAttribute("data-selected-variant-id", selectedVariant.id);
    });
  }

  getProductInfo(option) {
    const productInfoScript = option.querySelector(
      "script[data-product-information]"
    );
    if (!productInfoScript) return;

    const productData = JSON.parse(productInfoScript.textContent);

    return productData;
  }

  validateForm() {
    this.addToCartButton.disabled = !(
      this.termsInput.checked && this.getSelectedOption()
    );
  }

  addToCart() {
    const selectedOption = this.getSelectedOption();
    if (!selectedOption) return;

    // directly to checkout
    window.location.href = `/cart/clear?return_to=/cart/add?items[][id]=${selectedOption.dataset.selectedVariantId}%26items[][quantity]=1%26return_to=/checkout`;
  }
}

customElements.define("truckload-form", TruckloadForm);
